import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusToolbarFab], campus-toolbar-fab',
})
export class ToolbarFabDirective {
  // @HostBinding('class.shared-toolbar__fab')
  // hasToolbarFab = true;
}
